import { FC } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/Dialog/Dialog'
import { AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { useTranslation } from 'react-i18next'
import { CreateWebinarForm } from '@/features/Webinar/CreateWebinarForm'

type CreateWebinarModalProps = {
  dialogProps: AlertDialogProps
  onCloseModal: () => void
}

export const CreateWebinarModal: FC<CreateWebinarModalProps> = props => {
  const { dialogProps, onCloseModal } = props
  const { t } = useTranslation(['webinar'])
  return (
    <Dialog {...dialogProps}>
      <DialogContent className={'overflow-y-auto max-h-[95vh]'}>
        <DialogHeader>
          <DialogTitle>{t('webinar:create_webinar_modal_title')}</DialogTitle>
          <CreateWebinarForm onCloseModal={onCloseModal} />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
